import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "./User";
import Badges from "./Badges";
import db from "../firebase";
import useCookie from "../hooks/useCookie";
import ConfettiComp from "./ConfettiComp";
import { addDoc, orderBy, query } from "firebase/firestore";
import Cookies from "js-cookie";
import { doc, onSnapshot, updateDoc, collection } from "@firebase/firestore";
import Score from "./Score";
import HeaderGreetings from "./HeaderGreetings";
import PopUpMessage from "./PopUpMessage";
import ReactPlayer, { getCurrentTime } from "react-player/vimeo";
import BusinessCard from "./BusinessCard";
import { NavLink } from "react-router-dom";
import Wallet from "./Wallet";
// import DATA from './Data';
import ProgressBar from "./ProgressBar";
// import { AchievementTiersComponent } from "@insertcoinab/gwen-react-components";
import ProgressBar2 from "./ProgressBar2";
import AppleSvg from "../assets/walletcard.svg";

const Profile = () => {
	let cookie = Cookies.get().id;
	const [value, update, remove] = useCookie("id", cookie);
	const [fire, setFire] = useState(false);
	const [users, setUsers] = useState([]);
	const [rating, setRating] = useState(1);
	const [score, setScore] = useState(0);
	const [userAvatar, setUserAvatar] = useState("/img/avatar-1.png");
	const [badge1, setBadge1] = useState(false);
	const [badge2, setBadge2] = useState(false);
	const [image, setImage] = useState();
	const [name, setName] = useState("");
	const [emailSent, setEmailSent] = useState(false);
	const [avatar, setAvatar] = useState("/img/avatar-1.png");
	const [voucher, setVoucher] = useState("You have no active vouchers");
	const { user, setUser } = useContext(UserContext);
	const [badgeQuiz, setBadgeQuiz] = useState(false);
	const [badgeVideo, setBadgeVideo] = useState(false);
	const [badgeDownload, setBadgeDownload] = useState(false);
	const [companyName, setCompanyName] = useState("");
	const [badgeCompany, setBadgeCompany] = useState(false);
	const [popup, setPopup] = useState(false);
	const [popupAdd, setPopupAdd] = useState("");
	const [popupEmoji, setPopupEmoji] = useState("");
	const [popupHeading, setPopupHeading] = useState("");
	const [popupContent, setPopupContent] = useState("");
	const [popupText, setPopupText] = useState("");
	const [classChange, setClassChange] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [buttonForDetails, setButtonForDetails] = useState("Show Details");
	const [percentage1, setPercentage1] = useState(0);
	const [percentage2, setPercentage2] = useState(0);
	const [progress1, setProgress1] = useState(0);
	const [progress2, setProgress2] = useState(0);
	const [totalPoints, setTotalPoints] = useState("");
	const [userPoints, setUserPoints] = useState(0);

	const voucherUsed = () => {
		setVoucher("You have no vouchers to use");
	};

	const handleClickSocial = () => {
		setFire(true);
		setPopup(false);
		window.open(
			"https://www.instagram.com/envyapples/?hl=en",
			"_blank",
			"fullscreen=yes"
		);
	};

	const handleShowDetails = () => {
		buttonForDetails === "Show Details"
			? setButtonForDetails("Back to card")
			: setButtonForDetails("Show Details");
		setShowDetails(!showDetails);
	};

	// useEffect(() => {
	// 	if (fire) {
	// 		setTimeout(() => {
	// 			navigate("/");
	// 		}, 2000);
	// 	}
	// }, [fire]);

	const classChanger = (e, heading) => {
		setPopupContent(e.target["src"]);
		setPopupHeading(heading);
		setClassChange(!classChange);
		if (heading === "Avatar") {
			setPopupText("Your unique avatar has been unlocked.");
			setPopupAdd("");
			// } else if (heading === "Social") {
			// 	setPopupText(
			// 		`Thank you for following us on Instagram`
			// 	);
			// 	setPopupEmoji("🗣️")
			// 	setPopupText("Visit our Instagram profile");
			// 	setPopupAdd(
			// 		<button className="download-btn" onClick={handleClickSocial}>
			// 			Go to instagram
			// 		</button>
			// 	);
			// } else if (heading === "Poll") {
			// 	setPopupText(
			// 		`Your favorite use of a premium apple is ${user.progress.packet_1.activities.poll.answer}`
			// 	);
			// 	if (user.progress.packet_1.activities.poll.answer === "Dessert") {
			// 		setPopupEmoji("🧁");
			// 	} else if (user.progress.packet_1.activities.poll.answer === "Light Mains") {
			// 		setPopupEmoji("🥙");
			// 	} else if (user.progress.packet_1.activities.poll.answer === "Salads") {
			// 		setPopupEmoji("🥗");
			// 	} else if (user.progress.packet_1.activities.poll.answer === "Pairings") {
			// 		setPopupEmoji("🍷");
			// 	}
			// 	setPopupAdd("");
		} else if (heading === "Quiz") {
			setPopupText(
				`Your drink of choice is ${user.progress.packet_1.activities.quiz.answer}`
			);
			setPopupEmoji("🥂");
			setPopupAdd("");
		} else if (heading === "Mint") {
			setPopupText("You can also access your minted NFT in Solana");
			setPopupAdd("");
		} else if (heading === "Free drink") {
			setPopupContent(
				"https://ucarecdn.com/26395a81-c280-4b16-8ebd-ecfaea465ae9/-/crop/1632x917/0,0/-/preview/-/quality/lighter/-/format/auto/-/scale_crop/1920x1080/center/"
			);
			setPopupText("Follow given instructions to redeem the code");
		} else if (heading === "PDF") {
			setPopupEmoji("📄");
			setPopupText("You can view your pdf again here: ");
			setPopupAdd(
				<button className="download-btn" onClick={handleClickDownload}>
					View PDF
				</button>
			);
		} else if (heading === "Video") {
			setPopupEmoji("🎥");
			setPopupText("Watch your video again");
			setPopupAdd(
				<div className="video-wrapper">
					<ReactPlayer
						controls
						config={{
							vimeo: {
								playerOptions: {
									autoplay: false,
									background: false,
								},
							},
						}}
						width="100%"
						height="165%"
						url="https://vimeo.com/738487002"
					/>
				</div>
			);
		} else if (heading === "Company") {
			setPopupText("");
			setPopupAdd(
				<div>
					<div className="company-details">
						Your company is <span id="company-name">{user.companyName}</span>
					</div>
					<div className="company-details">
						Your corporate email is: {user.corporateEmail}
					</div>
				</div>
			);
			setPopupEmoji("🏢");
		}
	};

	useEffect(() => {
		if (classChange) {
			setPopup(true);
		} else {
			setPopup(false);
		}
	}, [classChange]);
	var i = 0;
	var sentMail = false;

	useEffect(() => {
		const update = async (packet_id) => {
			const user_ref = await doc(db, "users", Cookies.get().id);
			if (packet_id === "packet_1") {
				setBadge1("is_awarded");
				setFire(true);
				setPopup(true);
				setPopupHeading("Your Wallet");
				setPopupText("View your earned collectables in a Wallet");
				setPopupAdd(
					<NavLink to="/profile">
						<button className="download-btn">View Wallet</button>
					</NavLink>
				);
				await updateDoc(user_ref, {
					// "progress.packet_1.packet_completed": true,
					"progress.packet_1.badge.is_awarded": true,
				});
				// await addDoc(collection(db, "mail"), {
				// 	to: user.email,
				// 	message: {
				// 		subject: `Hello from the world of Lagoon, ${user.firstName}! `,
				// 		html: `<p>Hi, ${user.firstName}!</p><br><p>Thank you for joining the Lagoon platform demo. Power your live events with connected 1:1 experiences that Increase user engagement and conversion. From gamification to avatars, augmented reality to interactive content, you can extend every screen&ndash;digital signage, web and marquee&ndash;to create personal interactions.</p>				<p>&nbsp;</p>				<p>Feel free to reach out to me by responding to this email.&nbsp;</p>				<p>&nbsp;</p>				<p>You can always revisit your experience with this link on your mobile device.&nbsp;<a href="https://app.lagoonlive.com/">https://app.lagoonlive.com</a>&nbsp;</p>				<img width="250px" height="250px" style="margin-top: 20px; margin-bottom: 10px; max-width: 250px; width: 250px; height: 250px;" src="https://firebasestorage.googleapis.com/v0/b/lagoon-118b4.appspot.com/o/qr-2.png?alt=media&token=daf34fd1-a68c-4124-a934-aca187462a7d">				<p>&nbsp;</p>				<hr>				James Rice<br>				503-734-6474<br>				<a href="mailto:james@lagoonlive.com">james@lagoonlive.com</a>`,
				// 	},
				// });
			} else if (packet_id === "packet_2") {
				setBadge2("is_awarded");
				setPopup(true);
				setPopupHeading("Your Wallet");
				setPopupText("View your earned collectables in a Wallet");
				setPopupAdd(
					<NavLink to="/profile">
						<button className="download-btn">View Wallet</button>
					</NavLink>
				);
				await updateDoc(user_ref, {
					"progress.packet_2.packet_completed": true,
					"progress.packet_2.badge.is_awarded": true,
				});
			}
		};
		if (user.progress) {
			const userProgress1 = user.progress["packet_1"];
			const userProgress2 = user.progress["packet_2"];

			setPercentage1((userProgress1.package_points / 20) * 44);
			setPercentage2((userProgress2.package_points / 25) * 56);
			setProgress1(userProgress1.package_points);
			setProgress2(userProgress2.package_points);

			setUserPoints(
				`${
					userProgress1.package_points + userProgress2.package_points === 0
						? ""
						: `${
								userProgress1.package_points + userProgress2.package_points
						  }`
				}`
			)

			setTotalPoints(
				`${
					userProgress1.package_points + userProgress2.package_points === 0
						? ""
						: `${
								userProgress1.package_points + userProgress2.package_points
						  }`
				}`
			);
			setBadge1(
				userProgress1.badge.is_awarded
					? "is_awarded"
					: userProgress1.badge.is_unlocked
					? "is_activated"
					: "locked"
			);
			setBadge2(
				userProgress2.badge.is_awarded
					? "is_awarded"
					: userProgress2.badge.is_unlocked
					? "is_activated"
					: "locked"
			);
			if (
				Object.values(userProgress1.activities).every(
					(value) => value.completed === true
				)
			) {
				if (!userProgress1.badge.is_awarded) {
					update("packet_1");
				}
			}
			if (
				Object.values(userProgress2.activities).every(
					(value) => value.completed === true
				)
			) {
				if (!userProgress2.badge.is_awarded) {
					update("packet_2");
				} else {
				}
			}
		}
	}, [user.progress]);

	useEffect(() => {
		if (user) {
			setImage(user.logoUrl);
			setVoucher(user.drinkCode);
			setCompanyName(user.companyName);
		}
		if (user.progress) {
			setAvatar("/img/avatar-1.png");
		}
	}, [user]);

	useEffect(() => {
		const unsub = onSnapshot(
			query(collection(db, "users"), orderBy("score", "desc")),
			(snapshot) => {
				setUsers(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
			}
		);
		return () => unsub();
	}, []);

	useEffect(() => {
		if (users) {
			users.forEach((user, i) => {
				if (user.id === cookie) {
					setRating(i + 1);
					setScore(user.score);
					setUserAvatar(user.avatarUrl);
					setName(user.firstName);
					setUser(user);
				}
			});
		}
	}, [users]);

	return (
		<>
			<div className="profile">
				<ConfettiComp fire={fire} />
				{user.avatarRevealed ? (
					<HeaderGreetings name={name} avatar={userAvatar} score={score} />
				) : (
					<HeaderGreetings name={name} avatar={avatar} score={score} />
				)}
				<div style={{ marginTop: "20px" }} className="wallet-btn-wrapper">
					<BusinessCard />
					<a className="applewalletcard" href="https://pub1.pskt.io/t/ey2a2h" target="_blank">
						<img className="applewalletcard" src={AppleSvg}></img>
					</a>
				</div>

				<div className="profile-wrapper">
					{/* <div className="dash"></div> */}
					<p className="profile-titles">Your collectibles </p>
					<Wallet />
					<p className="profile-titles mb-11">Your stats </p>
					<Score score={score} rating={rating} />
					<div className="badges">
						<p className="profile-titles">Badges </p>
						{/* <AchievementTiersComponent achievement={{
							    id: 0,
								behaviorId: "ello",
								tiers: [
									{
										title: "module 1",
										description: "descr",
										amount: score,
										progress: 30,
										rewards: []
									},
									// {
									// 	title: "module 2",
									// 	description: "descr",
									// 	amount: 30, 
									// 	progress: 10,
									// 	rewards: []
									// }
								],
								tag: "string",
								title: "title",
								description: "descr",
								icon: "prize",
								metadata: "mD",
								tagKey: "tK",
								active: "true",
								cta: "cta",
						}} /> */}
						<p style={{ marginTop: "-10px" }} className="home-titles">Rewards progress </p>
						{/* <ProgressBar
							visualParts={{
								percentage1: percentage1,
								percentage2: percentage2,
								points1: progress1,
								points1: progress2,
								totalPoints: totalPoints,
								background: "linear-gradient(to right, #e337ff, #882aff)",
								text: "",
							}}
						/> */}
						{/* // Older */}
						<ProgressBar2
							totalPoints={45}
							visualParts={[
								{
									percentage: percentage1,
									// background: "linear-gradient(to right, #661490, #470c65)",
									background: "linear-gradient(180deg, #e337ff 0%, #882aff 100%)",
									// background: "#882aff",
									text: "Module one",
									points: ""
								},
								{
									percentage: percentage2,
									background: "linear-gradient(180deg, #e337ff 0%, #882aff 100%)",
									// background: "linear-gradient(to left, #661490, #470c65)",
									// background: "#e337ff",
									text: `Module two`,
									points: `${totalPoints}`
								},
							]}
						/>
						<Badges badge1={badge1} badge2={badge2} />
					</div>
				</div>
				{/* <button classname="logout-btn" onClick={sendEmail}>
					Send Email
				</button> */}
				{/* <button className="logout-btn" onClick={remove}>
					Logout
				</button> */}
				{/* <Footer /> */}
			</div>
		</>
	);
};

export default Profile;
